import { render, staticRenderFns } from "./Usage.vue?vue&type=template&id=f06abace&"
import script from "./Usage.vue?vue&type=script&lang=js&"
export * from "./Usage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f06abace')) {
      api.createRecord('f06abace', component.options)
    } else {
      api.reload('f06abace', component.options)
    }
    module.hot.accept("./Usage.vue?vue&type=template&id=f06abace&", function () {
      api.rerender('f06abace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/billing/Usage.vue"
export default component.exports